"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const merge_1 = __importDefault(require("../../utils/immutable/merge"));
const intlCache = (0, react_intl_1.createIntlCache)();
function IntlProvider(props) {
    const ref = (0, react_1.useRef)();
    const messages = (0, react_1.useMemo)(() => { var _a; return (0, merge_1.default)((_a = ref.current) !== null && _a !== void 0 ? _a : {}, props.messages); }, [props.locale, props.messages]);
    (0, react_1.useEffect)(() => {
        if (ref.current !== messages) {
            ref.current = messages;
        }
    }, [messages]);
    const intl = (0, react_1.useMemo)(() => (0, react_intl_1.createIntl)({
        messages,
        locale: props.locale,
        defaultLocale: props.defaultLocale,
    }, intlCache), [props.locale, messages, props.defaultLocale]);
    (0, react_1.useEffect)(() => {
        if (intl && window.___decentralandGatsbyIntl !== intl) {
            window.___decentralandGatsbyIntl = intl;
        }
    }, [intl]);
    return react_1.default.createElement(react_intl_1.RawIntlProvider, { value: intl }, props.children);
}
exports.default = IntlProvider;
